import importAnalytics from './importAnalytics';
import indicatorLoadMonitoring from './indicatorLoadMonitoring';
import keyCountryIndicator from './keyCountryIndicator';
import priorityImportAndImportDestination from './priorityImportAndImportDestination';

export default {
  keyCountryIndicator,
  priorityImportAndImportDestination,
  importAnalytics,
  indicatorLoadMonitoring,
};
